var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4E592;}\n\t.st1{fill:#9DCEE3;}\n\t.st2{fill:#C2E5F0;}\n\t.st3{fill:#374A5E;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#9ACDE3;}\n\t.st6{fill:#5CB28C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.7,39.9H32.4c-6.1,0-11.1,5.1-11.1,11.3v10v0v3.4h3.4h149.6h3.4v-3.4v0v-10 C177.8,45,172.8,39.9,166.7,39.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 64.6,
    className: "st4",
    width: 156.5,
    height: 94.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.3,53.9c0-1.8-1.5-3.3-3.3-3.3H64c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3h50 C115.9,57.2,117.3,55.7,117.3,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,50.6c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3 C54.7,52.1,53.2,50.6,51.4,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.5,50.6c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3 C44.8,52.1,43.3,50.6,41.5,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.6,50.6c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3 C34.9,52.1,33.5,50.6,31.6,50.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.4,1041.2l4.6,43.4l8.7-8.1l8,13.8l10.8-6.2l-8-13.8l11.3-3.5L83.4,1041.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodle);
export default __webpack_public_path__ + "static/media/moodle.75c09f1cb19e5ce68cb9375a8a62779f.svg";
export { ForwardRef as ReactComponent };